<template>
  <div class="app-detail-wrap container" v-loading="loading">
    <template v-if="detail.D_ID_">
      <section class="top">
        <div class="app-detail">
          <div class="icon">
            <el-image :src="downloadUrl + detail.APPICO" fit="contain">
              <div slot="error" class="error">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <div class="detail">
            <p class="name">{{ detail.APPNAME }}</p>
            <p class="type text_info">
              <el-tag type="info" v-if="detail.CLASSIFYNAME">{{
                detail.CLASSIFYNAME
              }}</el-tag>
              <el-tag type="info" v-if="detail.BMMC">{{ detail.BMMC }}</el-tag>
              <el-tag type="info" v-if="detail.FWFSMC">{{
                detail.FWFSMC
              }}</el-tag>
              <el-tag type="info" v-if="detail.FWCJMC">{{
                detail.FWCJMC
              }}</el-tag>
            </p>
            <div class="data">
              <span class="font_color_main">{{
                detail.USECOUNT | countFilter
              }}</span>
              次使用
              <mrate v-model="detail.SCORE" disabled></mrate>
            </div>
          </div>
        </div>

        <div class="operate">
          <!-- 可以使用才可以收藏或打分 -->
          <template v-if="detail.PERMISSION == '1' && userInfo.userId">
            <div class="collect">
              <span
                v-if="detail.HASCOLLECTION != '1'"
                title="点击收藏"
                @click="changeCollect(true)"
              >
                <i class="el-icon-star-off"></i> 收藏
              </span>
              <span
                v-else
                class="font_color_main"
                title="点击取消收藏"
                @click="changeCollect(false)"
              >
                <i class="el-icon-star-on"></i> 已收藏
              </span>
            </div>
            <div class="rate" title="点击打分" @click="openRateDialog">
              <el-popover
                v-if="detail.MYSCORE > 0"
                placement="top"
                width="170"
                trigger="hover"
              >
                <mrate v-model="detail.MYSCORE" disabled></mrate>
                <span slot="reference">
                  <i class="el-icon-edit-outline font_color_main"></i>
                  <span class="font_color_main">已打分</span>
                </span>
              </el-popover>
              <template v-else>
                <i class="el-icon-edit-outline"></i> 打分
              </template>
            </div>
          </template>

          <!-- -1 未登录， 0 没有权限， 1 有权限 -->
          <div class="no_login" v-if="detail.PERMISSION == '-1'">
            <el-button type="success" @click="loginFun">立即登录</el-button>
            <p class="text_info">该服务必须登录后才能使用</p>
          </div>
          <el-button type="info" v-else-if="detail.PERMISSION == '0'"
            >权限不足</el-button
          >
          <el-button
            type="primary"
            @click="openApp"
            v-else-if="detail.PERMISSION == '1'"
            >立即使用
          </el-button>
        </div>
      </section>

      <section class="detail">
        <mswiper
          v-if="imgList.length"
          ref="swiper"
          class="slider"
          pClass=".app-detail-wrap"
          slidesPerView="auto"
          :datas="imgList"
        >
          <div slot-scope="scope" class="app-slider">
            <el-image
              :src="scope.item"
              fit="cover"
              :preview-src-list="imgList"
            ></el-image>
          </div>
        </mswiper>

        <div class="desc">
          <h3>服务简介</h3>
          <div v-html="detail.APPDETAIL"></div>
        </div>
      </section>
    </template>

    <empty
      v-else-if="!loading"
      margin="150px"
      text="抱歉，没有找到该服务！"
    ></empty>

    <el-dialog
      custom-class="rate-dialog"
      title="请打分"
      center
      :visible.sync="dialogVisible"
      width="500px"
    >
      <mrate v-model="rateFormVal"></mrate>

      <span slot="footer" class="dialog-footer">
        <el-button :loading="dialogLoading" @click="dialogVisible = false"
          >放弃</el-button
        >
        <el-button
          :loading="dialogLoading"
          type="primary"
          @click="saveRate"
          :disabled="!rateFormVal"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Base64 } from 'js-base64'
import mswiper from '@/components/swiper'
import mrate from '@/components/rate'
import { mapGetters } from 'vuex'

export default {
  components: {
    mswiper,
    mrate
  },
  data() {
    return {
      downloadUrl: global.baseApi + '/api/hall/file/download/',
      loading: false,
      detail: {},
      imgList: [],
      myScore: {},
      dialogVisible: false,
      rateFormVal: 0,
      dialogLoading: false
    }
  },
  filters: {
    countFilter(val) {
      if (val > 9999) {
        return '9999+'
      }
      return val || 0
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    if (this.$route.query.app) {
      this.getDetail(this.$route.query.app)
    }
  },
  methods: {
    // 新标签页打开服务  isHall 用于已有系统识别是从大厅跳转过来了
    openApp() {
      window.open(
        global.baseApi + '/api/hall/jump/' + this.detail.D_ID_ + '?isHall=1'
      )
    },
    loginFun() {
      window.location.href =
        global.baseApi +
        '?redirect_url=' +
        Base64.encode(document.location.href)
    },
    getDetail(id) {
      this.loading = true
      this.$axios.post(`/api/hall/app/details/${id}`).then(res => {
        this.loading = false
        if (res.result) {
          this.detail = res.data || {}
          if (Array.isArray(this.detail.RESOURCES)) {
            this.detail.RESOURCES.forEach(file => {
              file.url = this.downloadUrl + file.resId
              this.imgList.push(file.url)
            })
            this.$nextTick(() => {
              this.$refs.swiper && this.$refs.swiper.$refs.swiper.update()
            })
          }
        }
      })
    },
    // 收藏改变
    changeCollect(type) {
      if (type) {
        this.addCollect()
      } else {
        this.$confirm('确定取消收藏该服务吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.cancelCollect()
          })
          .catch(() => {})
      }
    },
    // 添加收藏
    addCollect() {
      this.loading = true
      this.$axios
        .post('/api/hall/addCollection', [
          {
            appid: this.detail.D_ID_
          }
        ])
        .then(res => {
          this.loading = false
          if (res.result) {
            this.detail.HASCOLLECTION = '1'
          }
        })
    },
    // 取消收藏
    cancelCollect() {
      this.loading = true
      this.$axios
        .post('/api/hall/delCollection', [this.detail.D_ID_])
        .then(res => {
          this.loading = false
          if (res.result) {
            this.detail.HASCOLLECTION = ''
          }
        })
    },
    // 打开评分
    openRateDialog() {
      this.rateFormVal = 0
      this.dialogVisible = true
    },
    saveRate() {
      this.dialogLoading = true
      this.$axios
        .post('/api/my/app/comment', {
          appid: this.detail.D_ID_,
          score: this.rateFormVal
        })
        .then(res => {
          this.dialogLoading = false
          if (res.result) {
            this.dialogVisible = false
            this.detail.MYSCORE = this.rateFormVal
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/var.scss';

.app-detail-wrap {
  padding: 35px 15px 15px;
  min-height: 600px;
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    border-bottom: 1px solid #d6d6d6;
    margin-bottom: 25px;
    .app-detail {
      flex: 1;
      width: 0;
      display: flex;
      align-items: center;
      .icon {
        flex: none;
        width: 120px;
        height: 120px;
        text-align: center;
        line-height: 118px;
        border: 1px solid #dfdfdf;
        margin-right: 20px;
        img {
          max-width: 95%;
          max-height: 95%;
          vertical-align: middle;
        }
      }
      .detail {
        .name {
          font-size: 26px;
        }
        .type {
          margin: 10px 0 15px;
          .el-tag {
            margin-right: 10px;
          }
        }
        .data {
          /deep/ .mrate {
            display: inline-block;
            margin-left: 20px;
          }
        }
      }
    }
    .operate {
      flex: none;
      margin-left: 30px;
      display: flex;
      align-items: center;
      .no_login {
        text-align: center;
        .text_info {
          font-size: 14px;
          margin-top: 15px;
        }
      }
      .collect {
        margin-right: 20px;
        color: #666;
        & > span {
          cursor: pointer;
          &:hover {
            color: var(--main);
          }
        }
        i {
          font-size: 18px;
        }
      }
      .rate {
        cursor: pointer;
        margin-right: 50px;
        color: #666;
        .el-icon-edit-outline {
          font-size: 18px;
        }
        .mrate {
          visibility: hidden;
        }
        &:hover {
          color: var(--main);
        }
      }
    }
  }
  .detail {
    .slider {
      /deep/.swiper-slide {
        display: inline-block;
        width: auto;
      }
      .app-slider {
        width: 450px;
        height: 500px;
        padding: 30px 20px;
        .el-image {
          width: 100%;
          height: 100%;
        }
      }
    }
    .desc {
      margin-top: 30px;
      line-height: 1.5;
      white-space: pre-wrap;
      word-break: break-word;
      h3 {
        margin-bottom: 15px;
      }
    }
  }
}
.rate-dialog {
  .mrate {
    text-align: center;
    /deep/.el-rate {
      height: 28px;
    }
    /deep/.el-rate__icon {
      font-size: 30px;
    }
    /deep/.text_info {
      font-size: 24px;
    }
  }
}
</style>
